export class DataSanitizationUtils {
    // Returns trimmed string or null when empty/invalid
    static normalizeResourceIdValue(value?: string | null): string | null {
        if (typeof value !== 'string') {
            return null;
        }
        const trimmed = value.trim();
        if (!trimmed) {
            return null;
        }
        return trimmed;
    }

    // Splits an identifier of the form "PREFIX:value" into prefix/remainder.
    // If there is no prefix, prefix will be null and the entire value is returned as remainder.
    static splitResourceId(value?: string | null): { prefix: string | null; remainder: string } | null {
        const normalized = DataSanitizationUtils.normalizeResourceIdValue(value);
        if (!normalized) {
            return null;
        }

        const separatorIndex = normalized.indexOf(':');
        if (separatorIndex < 0) {
            return { prefix: null, remainder: normalized };
        }

        const rawPrefix = normalized.slice(0, separatorIndex).replace(/[^A-Za-z]/g, '').toUpperCase();
        const remainder = normalized.slice(separatorIndex + 1).trim();
        if (!remainder) {
            return null;
        }

        return {
            prefix: rawPrefix || null,
            remainder,
        };
    }

    // Ensures a value carries the desired prefix. If already prefixed (case-insensitive), returns unchanged.
    static ensureResourcePrefix(prefix: string, value?: string | null): string | null {
        const normalized = DataSanitizationUtils.normalizeResourceIdValue(value);
        if (!normalized) {
            return null;
        }
        const target = `${prefix.toUpperCase()}:`;
        if (normalized.toUpperCase().startsWith(target)) {
            return normalized;
        }
        return `${prefix}:${normalized}`;
    }
}